'use strict'

$id = $('body').attr('id')
$class = $('body').attr('class')

if $class.indexOf('index') isnt -1
  ScrollReveal().reveal('.text1 .sub1__1',{
    delay: 800,
    duration: 1000,
    viewFactor: 0.2,
    reset: false
  })

  ScrollReveal().reveal('.text1 .sub2__1',{
    delay: 1000,
    duration: 1000,
    viewFactor: 0.2,
    reset: false
  })

  ScrollReveal().reveal('.text1 .sub1__2',{
    delay: 1200,
    duration: 1000,
    viewFactor: 0.2,
    reset: false
  })

  ScrollReveal().reveal('.text1 .sub2__2',{
    delay: 1400,
    duration: 1000,
    viewFactor: 0.2,
    reset: false
  })

  ScrollReveal().reveal('.text1 .sub1__3',{
    delay: 1600,
    duration: 1000,
    viewFactor: 0.2,
    reset: false
  })

  ScrollReveal().reveal('.text2',{
    delay: 1800,
    duration: 1000,
    viewFactor: 0.2,
    reset: false
  })

  # fixElement1 = $('.subbox1 .pic')
  # fixElement2 = $('.subbox2 .pic')
  # fixElement3 = $('.subbox3 .pic')
  # fixElement4 = $('.subbox4 .pic')
  # endElement1 = $('.subbox2')
  # endElement2 = $('.subbox3')
  # endElement3 = $('.subbox4')
  # endElement4 = $('.menu-link')
  # baseFixPoint1 = fixElement1.offset().top
  # baseFixPoint2 = fixElement2.offset().top
  # baseFixPoint3 = fixElement3.offset().top
  # baseFixPoint4 = fixElement4.offset().top
  # endPoint1 = endElement1.offset().top - fixElement1.outerHeight(true) - $('#gnavi').outerHeight(true)
  # endPoint2 = endElement2.offset().top - fixElement2.outerHeight(true) - $('#gnavi').outerHeight(true)
  # endPoint3 = endElement3.offset().top - fixElement3.outerHeight(true) - $('#gnavi').outerHeight(true)
  # endPoint4 = endElement4.offset().top - fixElement4.outerHeight(true) - $('#gnavi').outerHeight(true)
  #
  # $(window).on('scroll',
  #   ()->
  #     fixFunction()
  # )
  #
  # fixFunction = ()->
  #   winScroll = $(window).scrollTop()
  #
  #   if winScroll > baseFixPoint1 - $(window).height()
  #     $('.subbox1 .pic_img').css({
  #       'transform': 'translate3d(0px, 0px, 0px)' + 'scale(' + (2 - (winScroll / 2000)) + ', ' + (2 - (winScroll / 2000)) + ')'
  #     })
  #   else
  #     $('.subbox1 .pic_img').css({
  #       'transform': 'scale(1, 1)'
  #     })
  #
  #   if winScroll > baseFixPoint2 - $(window).height()
  #     $('.subbox2 .pic_img').css({
  #       'transform': 'translate3d(0px, 0px, 0px)' + 'scale(' + (2 - (winScroll / 2000)) + ', ' + (2 - (winScroll / 2000)) + ')'
  #     })
  #   else
  #     $('.subbox2 .pic_img').css({
  #       'transform': 'scale(1, 1)'
  #     })
  #
  #   if winScroll > baseFixPoint3 - $(window).height()
  #     $('.subbox3 .pic_img').css({
  #       'transform': 'translate3d(0px, 0px, 0px)' + 'scale(' + (2 - (winScroll / 2000)) + ', ' + (2 - (winScroll / 2000)) + ')'
  #     })
  #   else
  #     $('.subbox3 .pic_img').css({
  #       'transform': 'scale(1, 1)'
  #     })
  #
  #   if winScroll > baseFixPoint4 - $(window).height()
  #     $('.subbox4 .pic_img').css({
  #       'transform': 'translate3d(0px, 0px, 0px)' + 'scale(' + (2 - (winScroll / 2000)) + ', ' + (2 - (winScroll / 2000)) + ')'
  #     })
  #   else
  #     $('.subbox4 .pic_img').css({
  #       'transform': 'scale(1, 1)'
  #     })
  #
  #   if window.matchMedia('(max-width:750px)').matches
  #     if winScroll >= baseFixPoint - $('.l-header').outerHeight(true)
  #       fixElement1.css({
  #         'position': 'fixed'
  #         'top': $('.l-header').outerHeight(true)
  #       })
  #
  #       if winScroll >= endPoint
  #         fixElement1.css({
  #           'position': 'absolute',
  #           'top': 'auto',
  #           'bottom': 0
  #         })
  #     else
  #       fixElement1.removeClass(fixClass)
  #
  #       fixElement1.css({
  #         'position': '',
  #         'top': ''
  #       })
  #   else
  #     if winScroll >= baseFixPoint1 - $('#gnavi').outerHeight(true)
  #       fixElement1.css({
  #         'position': 'fixed'
  #         'top': $('#gnavi').outerHeight(true)
  #       })
  #
  #       if winScroll >= endPoint1
  #         fixElement1.css({
  #           'position': 'absolute',
  #           'top': 'auto',
  #           'bottom': 0
  #         })
  #     else
  #       fixElement1.removeClass(fixClass)
  #
  #       fixElement1.css({
  #         'position': '',
  #         'top': ''
  #       })

if $class.indexOf('details') isnt -1
  # if window.matchMedia('(max-width:750px)').matches
  #   swiper = new Swiper('.swiper-container', {
  #     loop: true,
  #     pagination: {
  #       el: '.swiper-pagination',
  #     },
  #     navigation: {
  #       nextEl: '.swiper-button-next',
  #       prevEl: '.swiper-button-prev',
  #     }
  #   })
  # else
  #   swiper = new Swiper('.swiper-container', {
  #     direction: 'vertical',
  #     loop: true,
  #     mousewheel: {
  #       invert: true,
  #     },
  #     pagination: {
  #       el: '.swiper-pagination',
  #     },
  #     navigation: {
  #       nextEl: '.swiper-button-next',
  #       prevEl: '.swiper-button-prev',
  #     }
  #   })

  $('.p-case .photo-main__item .photo-main__item__pic').twentytwenty()

  $('.photo-sub__item a[href^="#"]').each(
    (e)->
      $(this).off('click.smoothScroll')
  )

  $('.photo-sub__item a[href^="#"]').on('click',
    (e)->
      $parent = $(this).closest('.photo')
      e.preventDefault()
      $parent.find('.photo-sub__item').removeClass('is-active')
      $(this).parent().addClass('is-active')
      $parent.find('.photo-main__item').removeClass('is-active')
      $($(this).attr('href')).addClass('is-active')
  )
